import React from 'react';
import { Button } from 'antd';
import styles from './styles.scss';

const FranzPodcast = ({ imageSrc, description, url, cta }) => {
  return (
    <div className={styles.layout}>
      <img src={imageSrc} className={styles.authorImage} />
      <div className={styles.authorInfo}>
        <div className={styles.description}>{description}</div>
        <a href={url} target="_blank" rel="noopener noreferrer">
          <Button>{cta}</Button>
        </a>
      </div>
    </div>
  );
};

export default FranzPodcast;
